import { Card, Table, Button } from "react-bootstrap";
import HamtdaaCheckModal from "../Modal/HamtdaaCheckModal";
import { useState, useEffect } from "react";
import GenericModalNote from "../Modal/GenericModalNote";
import FamilyService from "../../services/tfamily.service";
import Loader from "react-spinners/BarLoader";
function UntMembers(props) {
  useEffect(() => {});
  const [loading, setLoading] = useState(false);
  const removeMember = async ({ groupId, phoneNum, note }) => {
    try {
      setLoading(true);
      await FamilyService.removeMember(groupId, phoneNum, note);
      props.notify(
        "tr",
        "success",
        `${phoneNum} дугаартай хэрэгэглэгчийг амжилттай групп ээс хаслаа`
      );
      await props.refreshCollective();
    } catch (err) {
      console.log(err);
      props.notify("tr", "danger", err.message);
    } finally {
      setLoading(false);
    }
  };
  const adminChange = async ({ groupId, phoneNum, note }) => {
    try {
      setLoading(true);
      await FamilyService.adminChange(groupId, phoneNum, note);
      props.notify(
        "tr",
        "success",
        `${phoneNum} дугаартай тай хэрэгэглэгчийг админ болголоо.`
      );
      await props.refreshCollective();
    } catch (err) {
      props.notify("tr", "danger", err.message);
    } finally {
      setLoading(false);
    }
  };
  if (
    !props.collective ||
    !props.collective.unitel ||
    props?.collective?.unitel?.members?.length === 0
  ) {
    return (
      <Card>
        <Card.Header className="d-flex justify-content-between align-items-center">
          <Card.Title as="h4">Юнител Гишүүд</Card.Title>
        </Card.Header>
        <Card.Body>Одоогоор Хамтдаад бүртгэлгүй байна</Card.Body>
      </Card>
    );
  }

  const groupId = props?.collective?.unitel?.groupId;

  return (
    <Card>
      {loading ? <Loader /> : null}
      <Card.Header className="d-flex justify-content-between align-items-center mb-3">
        <Card.Title as="h4" className="mb-0">
          Юнител Гишүүд
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Table
          className="table-hover table-striped"
          style={{
            fontSize: "12px",
          }}
        >
          <thead>
            <tr>
              <th className="border-0">Утасны дугаар</th>
              <th className="border-0">Group Id</th>
              <th className="border-0">Member Type</th>
              <th className="border-0">status</th>
              <th className="border-0">Remove</th>
              <th className="border-0">Admin</th>
            </tr>
          </thead>
          <tbody>
            {props?.collective?.unitel?.members?.map((member) => (
              <tr key={member.phoneNumber}>
                <td>{member.phoneNumber || ""}</td>
                <td>{groupId || ""}</td>
                <td>{member.role || ""}</td>
                <td>{member.status || ""}</td>
                <td>
                  {member.is_admin !== 1 ? (
                    <GenericModalNote
                      onClick={removeMember}
                      params={{
                        phoneNum: member.phoneNumber,
                        groupId: props.collective.unitel.groupId,
                      }}
                      action={"Хасах"}
                      title={"Групп ээс гишүүн хасах"}
                      body={`Та ${member.phoneNumber} дугаартай гишүүнийг группээс хасахдаа итгэлтэй байна уу?`}
                    />
                  ) : null}
                </td>
                <td>
                  {member.role === "admin" ? null : (
                    <GenericModalNote
                      onClick={adminChange}
                      params={{
                        phoneNum: member.phoneNumber,
                        groupId: props.collective.unitel.groupId,
                      }}
                      action={"Админ болгох"}
                      title={"Админ солих"}
                      body={`Та ${member.phoneNumber} дугаартай гишүүнийг админ болгохдоо итгэлтэй байна уу?`}
                    />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
}
export default UntMembers;
